import React, { useState } from 'react';

const STATUS_OPTIONS = ['lead', 'contacted', 'negotiation', 'converted', 'lost', 'inactive'];

const EMPTY = {
  businessName: '', subCategories: '', businessCategory: '', city: '', state: '', country: '',
  website: '', email: '', phone: '', contactPerson: '', designation: '', GST: '',
  productsSummary: '', keywords: '', tags: '', notes: '', salesStage: 'lead',
};

const inputCls =
  'w-full bg-white/5 ring-1 ring-white/10 rounded-xl px-3 py-2 text-sm text-white placeholder-white/30 ' +
  'focus:outline-none focus:ring-2 focus:ring-violet-500 transition';
const labelCls = 'flex flex-col gap-1.5 text-[11px] font-semibold uppercase tracking-widest text-white/40';

export default function CompanyForm({ initial, onSave, onClose }) {
  const [form, setForm] = useState(() =>
    initial
      ? { ...EMPTY, ...initial, subCategories: (initial.subCategories || []).join(', '), keywords: (initial.keywords || []).join(', '), tags: (initial.tags || []).join(', ') }
      : EMPTY
  );
  const [saving, setSaving] = useState(false);
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.businessName.trim()) return;
    setSaving(true);
    try {
      await onSave({
        ...form,
        subCategories: form.subCategories.split(',').map((s) => s.trim()).filter(Boolean),
        keywords: form.keywords.split(',').map((s) => s.trim()).filter(Boolean),
        tags: form.tags.split(',').map((s) => s.trim()).filter(Boolean),
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center" onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full sm:max-w-xl max-h-[92vh] overflow-y-auto bg-[#14141C] ring-1 ring-white/10
                   rounded-t-3xl sm:rounded-3xl p-6 shadow-2xl shadow-black/50"
      >
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-lg font-bold tracking-tight text-white">{initial ? 'Edit Company' : 'New Company'}</h3>
          <button onClick={onClose} className="text-white/40 hover:text-white text-xl leading-none">✕</button>
        </div>
        <p className="text-xs text-white/40 mb-5">Fields marked * are required.</p>

        <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <label className={`${labelCls} sm:col-span-2`}>
            Company Name *
            <input className={inputCls} value={form.businessName} onChange={set('businessName')} required />
          </label>
          <label className={labelCls}>Categories <input className={inputCls} value={form.subCategories} onChange={set('subCategories')} placeholder="comma separated" /></label>
          <label className={labelCls}>Sub Category <input className={inputCls} value={form.businessCategory} onChange={set('businessCategory')} /></label>
          <label className={labelCls}>City <input className={inputCls} value={form.city} onChange={set('city')} /></label>
          <label className={labelCls}>State <input className={inputCls} value={form.state} onChange={set('state')} /></label>
          <label className={labelCls}>Country <input className={inputCls} value={form.country} onChange={set('country')} /></label>
          <label className={labelCls}>Website <input className={inputCls} value={form.website} onChange={set('website')} /></label>
          <label className={labelCls}>Email <input type="email" className={inputCls} value={form.email} onChange={set('email')} /></label>
          <label className={labelCls}>Phone <input className={inputCls} value={form.phone} onChange={set('phone')} /></label>
          <label className={labelCls}>Contact Person <input className={inputCls} value={form.contactPerson} onChange={set('contactPerson')} /></label>
          <label className={labelCls}>Designation <input className={inputCls} value={form.designation} onChange={set('designation')} /></label>
          <label className={labelCls}>GST <input className={inputCls} value={form.GST} onChange={set('GST')} /></label>
          <label className={labelCls}>
            Status
            <select className={inputCls} value={form.salesStage} onChange={set('salesStage')}>
              {STATUS_OPTIONS.map((s) => <option key={s} value={s} className="bg-[#14141C]">{s}</option>)}
            </select>
          </label>
          <label className={`${labelCls} sm:col-span-2`}>Products <textarea rows={3} className={inputCls} value={form.productsSummary} onChange={set('productsSummary')} /></label>
          <label className={labelCls}>Keywords <input className={inputCls} value={form.keywords} onChange={set('keywords')} placeholder="comma separated" /></label>
          <label className={labelCls}>Tags <input className={inputCls} value={form.tags} onChange={set('tags')} placeholder="comma separated" /></label>
          <label className={`${labelCls} sm:col-span-2`}>Notes <textarea rows={2} className={inputCls} value={form.notes} onChange={set('notes')} /></label>

          <div className="sm:col-span-2 flex justify-end gap-3 mt-2">
            <button type="button" onClick={onClose} className="px-4 py-2.5 rounded-xl text-sm font-medium bg-white/5 text-white/70 ring-1 ring-white/10 hover:bg-white/10 transition">
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="px-5 py-2.5 rounded-xl text-sm font-semibold text-white bg-gradient-to-r from-violet-600 to-fuchsia-500
                         hover:from-violet-500 hover:to-fuchsia-400 shadow-lg shadow-violet-900/30 disabled:opacity-50 transition"
            >
              {saving ? 'Saving…' : 'Save Company'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
